(function (global, factory) {
    factory(require('jquery'))
}(this, (function ($) { 'use strict';

    global.Registrations = {
        events: function() {
            Inputmask({
                regex: "^\\d{11}$",
                placeholder: "",
                showMaskFocus: false,
                showMaskOnHover: false,
                clearIncomplete: true
            }).mask(document.getElementById("r_vat_number"));

            $('form').submit(Registrations.form.submit);
        },
        form: {
            enable: function(form) {
                form.find('input, button').attr('disabled', false);
            },
            disable: function(form) {
                form.find('input, button').attr('disabled', true);
            },
            submit: function() {
                let form = $(this);
                let data = form.serialize();

                Registrations.form.disable(form);
                Registrations.errors.clear();

                $.post(
                    form.attr('action'),
                    data,
                    function() {
                        $('#thank-you').removeClass('d-none').addClass('d-lg-flex');

                        $('#form-container').removeClass('d-lg-flex').addClass('d-none');
                        $('#thank-you').removeClass('d-none').addClass('d-lg-flex');

                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({'event': 'richiesta-registrazione'});
                    },
                    "json"
                ).fail(function(data) {
                    let response = JSON.parse(data.responseText);
                    let errors = '';
                    $.each(response.errors, function(key, value) {
                        errors += '<li>' + value + '</li>';
                    });
                    Registrations.errors.show(form, errors);
                    Registrations.form.enable(form);
                });

                return false;
            }
        },
        errors: {
            show: function(form, errors) {
                form.before(
                    '<div id="errors" class="alert alert-danger">' +
                        '<ul class="mb-0">' +
                            errors +
                        '</ul>' +
                    '</div>'
                );
            },
            clear: function() {
                $('#errors').remove();
            }
        },
        init: function() {
            Registrations.events();
        },
    };

})));
